export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[700px] md:min-h-[780px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 mt-[72px]">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>每日更新 200+ 影视资源</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-foreground-950 leading-tight mb-4">
              苹果视频 · 全网热门影视
              <br className="hidden sm:block" />
              免费高清在线看
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-2">
              苹果视频汇聚久久视频、芒果视频、97视频、丝瓜视频等平台热门资源，专注提供免费高清电影和电视剧全集在线观看服务。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              全站采用智能加速技术，无需注册登录，点击即播，告别缓冲等待。无论是最新院线大片还是经典怀旧剧集，在这里都能找到高清完整版。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-serif">50000+</div>
                <div className="text-xs text-foreground-500 mt-1">高清片源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-serif">0缓冲</div>
                <div className="text-xs text-foreground-500 mt-1">智能加速</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-500 font-serif">免注册</div>
                <div className="text-xs text-foreground-500 mt-1">即点即看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观看热门影视
              </a>
              <a
                href="#features"
                onClick={(e) => handleScroll(e, '#features')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-700 font-medium rounded-lg hover:bg-background-200 transition-all duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解平台优势
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end animate-slide-in-right">
            <div className="relative w-full max-w-[520px]">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 via-accent-200/30 to-secondary-200/40 rounded-3xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20streaming%20entertainment%20visual%20with%20abstract%20film%20reel%20elements%20and%20soft%20glowing%20lights%2C%20modern%20minimalist%20design%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20clean%20composition%20with%20depth%2C%20digital%20media%20aesthetic%2C%20high%20quality%20editorial%20style%20with%20soft%20shadows%20and%20elegant%20atmosphere&width=1040&height=780&seq=hero-visual-2026&orientation=landscape"
                  alt="苹果视频在线观看高清影视"
                  className="w-full h-auto object-cover"
                  width="1040"
                  height="780"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}